import React from 'react';
import Modal from '../../../../Components/Modal/Modal';
import { QuestionnaireSchedule } from '../../../../Components/QuestionnaireList/QuestionnaireListItem';
import QuestionnairePlanning from './QuestionnairePlanning';
import { QuestionnaireModule } from '../../Enums/QuestionnaireModule.enum';
import { Size } from '../../../../Enums/Size.enum';

interface QuestionnairePlanningProps {
	opened: boolean;
	onClose: any;
	patientId?: string;
	schedule?: QuestionnaireSchedule;
	scheduleId?: string;
	questionnaireId?: string;
	module?: QuestionnaireModule;
}

export default function QuestionnairePlanningModal(
	props: QuestionnairePlanningProps,
) {
	const { opened, onClose } = props;

	if (!opened) {
		return <></>;
	}

	return (
		<Modal opened={opened} onClose={onClose}>
			<Modal.Header title={'component.questionnaires.questionnaireSettings'} />
			<Modal.Content contentScroll={true}>
				<QuestionnairePlanning {...props} />
			</Modal.Content>
		</Modal>
	);
}
